<template>
    <Window  :defaultShow=shows :title=title :appendToBody=toBody  @onClose="onClose" @onInitData="onInitData">
        <!-- 如果想全屏，需加class样式contnet_box -->
         <vxe-grid  ref="resultTable" v-bind="tableOptions" class="window-toolbar"  
                    @form-submit="onSubmitQuery" 
                    @current-change="currentChangeEvent" 
                    @cell-dblclick="onCellDoubleClick"
                    :radio-config="{trigger:'row'}">
             <!--使用 top 插槽-->
            <template v-slot:top> 
               <div class="toolbar"  style="border-top:1px solid #eee;background:#f5f7fa;">
                    <div class="flooter">
                        <span v-for="(bar,index) in toolBarItems" :class=bar.class :key=index @click=onEmitEvent(bar.click)><i class="iconfont">&#xe7e4;</i>{{bar.name}}</span>
                    </div>       	
                </div>   
            </template> 
         </vxe-grid>
    </Window>
</template>

<script>
import Window from './Window.vue';
import Toolbars from './../bar/Toolbar.vue'


const FormButtons=[{ span: 8, align: 'right', collapseNode: true,size:"mini",itemRender: { name: '$buttons', children: [{ props: { type: 'submit',content: '查询', status: 'primary' } }, { props: { type: 'reset',content: '重置' } }] }  }];

//分页信息
const PageConfig={
            total: 0,
            currentPage: 1,
            pageSize: 10,
            align: 'right',
            pageSizes: [10, 20, 50, 100, 200, 500],
            layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
            perfect: true
}

//完整配置示例
const GridOptions={
    height:"400px",
    URL:'',
    resizable: true,
    maxHeight:600,
    border:true,
    highlightHoverRow:true,
    highlightCurrentRow:true,
    formConfig: {
        titleWidth: 100,
        titleAlign: 'right',           
        items: [ 
            { field: 'companyName', title: '公司名称:', span: 8, size:"mini",itemRender: { name: 'input', attrs: { placeholder: '请输入查询条件' } } },
            { field: 'companyCode', title: '公司编码:', span: 8,size:"mini", itemRender: { name: 'input', attrs: { placeholder: '请输入查询条件' } } },
            { span: 8, align: 'right', collapseNode: true,size:"mini",itemRender: { name: '$buttons', children: [{ props: { type: 'submit',content: '查询', status: 'primary' } }, { props: { type: 'reset',content: '重置' } }] }  },
            {
              span: 8,
              folding: true
            },
        ],
        data: {
            goodsCode: '23',
            goodsDesc: ''
        }
    },
    toolBar:[{
        class:"toolbar-item edit_btn",
        name:"选取",
        click:"onNew"
    }],  
    data:[],  
    columns:[
            { type: 'checkbox', width: 60, fixed: 'left' },
            // { type: 'seq', width: 80,  title: '序号',fixed: 'left' },					
            { type: 'seq', width: 80,  field: 'companyId', title: '公司ID'},
            { field: 'companyCode', title: '公司编码'},
            { field: 'companyName', title: '公司名'}
    ],
    pagerConfig: {
            total: 0,
            currentPage: 1,
            pageSize: 10,
            align: 'right',
            pageSizes: [10, 20, 50, 100, 200, 500],
            layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
            perfect: true
    }

}
export default {
    name:"SearchWindow",
    components:{
        Window,Toolbars
    },
    props:{
       show:{
           Type:Boolean,
           default(){
               return false
           }
       },
       title:{
         Type:String,
         default(){
             return '查询窗口'
         }
       },
       windowToBody:{
           Type:Boolean,
           default(){
               return false
           }
       },
       title:String,
       url:{
           Type:String,
           required: true
       },
       config:Object
    },
    provide: {
		name: 'Garrett'
    },
    watch:{
      show(value){          
          this.$nextTick(() => {
              this.shows=value;
          })
      },
      windowToBody(nval,oldval){
           this.toBody=nval;
      }
    },
    data(){
        return {
            toBody:this.windowToBody,
            tableOptions:{
                height:"500px",
                resizable: true,
                maxHeight:700,
                border:true,
                highlightHoverRow:true,
                highlightCurrentRow:true,
                formConfig:this.config.formConfig,
                columns:this.config.tableConfig.columns||[],
                pagerConfig:PageConfig,

                data:this.config.tableConfig.data||[], 

            },
            shows:this.show,
            toolBarItems:this.config.toolbar||GridOptions.toolBar                        
        }
    },
    methods:{
        onEmitEvent(enventName){ 
           //console.log(this.$refs.resultTable); 
           this.$emit(enventName,this);
        },
        /**
         * 提交查询
         */
        onSubmitQuery(){ 
            let vm=this,{formConfig,data}=vm.tableOptions;
            this.loadServeData(formConfig.data,function(result){
                 vm.tableOptions.data=result.data.list;
            });
            // alert(JSON.stringify(formConfig.data))
        },
        /**
         * 打开窗体初始化数据
         */
        onInitData(){
            this.onSubmitQuery()
        },
        /**
         * 加载服务端数据
         */
        async loadServeData(data,cb){
            if(!data){
                return;
            }
            let queryData={
               page: 1,
	           pageSize: 100
            }
            let resResult = await this.$post(this.url,queryData);
            if(cb&&resResult){                
                cb(resResult);
            }
        },
        onClose(){
            this.shows=false;  
            this.$emit("onClose",this.shows);
        },
        beforeCreate(){
            debugger;
           this.initSelectTypeConfig();
            //初始化form配置
           this.initFormConfig();
           this.initTableConfig();
        },
        /**
         * 生成form配置项
         */
        initFormConfig(){
            if(!this.config.formConfig){
               this.config.formConfig={};
            }

            let formConfig=this.config.formConfig;
            //form项标题
            if(!formConfig["titleWidth"]){
                formConfig["titleWidth"]=100;
            }
            if(!formConfig["titleAlign"]){
                formConfig["titleAlign"]='right';
            }
            //form项
            if(!formConfig["items"]){
                formConfig["items"]=[].concat(this.formItems).concat(FormButtons);
            }
            formConfig["items"].concat(FormButtons);

            //form默认数据
            if(!formConfig["data"]){
                formConfig["data"]={};
            }
            //form配置项
            //this.tableOptions.formConfig=formConfig;         
        },
        initTableConfig(){            
            if(!this.config.tableConfig){
                this.config.tableConfig={};
            }
            if(!this.config.tableConfig.columns){
                this.config.tableConfig.columns=[];
            }
            if(!this.config.tableConfig.data){
                this.config.tableConfig.data=[];
            }
        },
        /**
         * 初始化表格toolbar
         */
        initTableToolbarConfig(){
            if(!this.config.toolbar){
                this.config.toolBar=GridOptions.toolBar;
            }
        },
        /**
         * 初始化radio配置
         */
        initSelectTypeConfig(){
            if(this.config.radioConfig){
               this.tableOptions.radioConfig=this.config.radioConfig;
            }else if(this.config.checkboxConfig){
                this.tableOptions.checkboxConfig=this.config.checkboxConfig;
            }
        },

        /**
         * 获取表格选取的记录
         */
        getSelectedRecords(){
          let dRecords = this.$refs.resultTable.getCheckboxRecords();
          return dRecords;
        },
        getRadioRecord(){
            let dRecords = this.$refs.resultTable.getRadioRecord();
            return dRecords;
        },
        /**
         * 单元格双击事件
         */
        onCellDoubleClick({row}){
            let vm=this;
            vm.$emit("onCellDblClick",row);
        },
        currentChangeEvent({row}){
            console.log(row)
        }
        
    }
    
}
</script>

<style lang="stylus">
// .vxe_g
//     .vxe-grid--form-wrapper
//         .vxe-row
//             .vxe-col--24
//                 width:30%

.vxe_g
    .vxe-grid--top-wrapper
        padding 0

</style>